import React, { useState, useEffect } from 'react';
import './Settings.css';
import Layout from '../NewHeader/Layout';
import axios from 'axios';
import { var_api } from '../constant';

const Switch = ({ isOn, handleToggle }) => {
    return (
        <div className="switch-container">
            <span className="switch-text">{isOn ? 'On' : 'Off'}</span>
            <div
                className={`switch ${isOn ? 'bg-green' : 'bg-gray'}`}
                onClick={handleToggle}
            >
                <div className={`circle ${isOn ? 'translate-x-6' : 'translate-x-0'}`}></div>
            </div>
        </div>
    );
};

const AdminSettings = () => {
    const [notificationsEnabled, setNotificationsEnabled] = useState(false);

    useEffect(() => {
      

        fetchTables();
    }, []);
    const fetchTables = async () => {
        const shop_id = localStorage.getItem('ShopId');
        const token = localStorage.getItem('Token');

        if (!shop_id || !token) {
            console.error("ShopId or Token is missing in localStorage.");
            return;
        }

        try {
            const response = await axios.get(`${var_api}settings/get/${shop_id}`, {
                headers: {
                    Authorization: `${token}`
                }
            });

            const user = response.data[0];

            // Map notifications (1 or 0) to a boolean
            const notificationsState = user.notifications === 1;
            console.log(user.notifications);
            setNotificationsEnabled(notificationsState);

            console.log("Fetched notifications state:", notificationsState);
        } catch (error) {
            console.error("Error fetching tables:", error);
            if (error.response) {
                console.error("Server response:", error.response);
            }
        }
    };
    const handleNotificationToggle = async () => {
        const shop_id = localStorage.getItem('ShopId');
        const token = localStorage.getItem('Token');

        if (!shop_id || !token) {
            console.error("ShopId or Token is missing in localStorage.");
            return;
        }

        const newNotificationState = !notificationsEnabled;
        const payload = { notifications: newNotificationState ? 1 : 0 };

        try {
            await axios.put(`${var_api}settings/put/${shop_id}`, payload, {
                headers: {
                    Authorization: `${token}`
                }
            });

            setNotificationsEnabled(newNotificationState);
            localStorage.setItem('notificationsEnabled', JSON.stringify(newNotificationState));

            console.log("Notification state updated successfully:", newNotificationState);
            fetchTables();
        } catch (error) {
            console.error("Error updating notification state:", error);
            if (error.response) {
                console.error("Server response:", error.response);
            }
        }
    };

    return (
        <Layout>
            <div className="settings-container">
                <div className="settings-box">
                    <h1 className="settings-header">Admin Settings</h1>
                    <div className="setting">
                        <h2 className="setting-header">Notifications</h2>
                        <Switch isOn={notificationsEnabled} handleToggle={handleNotificationToggle} />
                    </div>
                </div>
            </div>
        </Layout>
    );
};

export default AdminSettings;
